/**
 * 使用中ロットが複数あるときの選択シート（SPEC §7.1）。
 * 1 本しか無いときはこのシートを出さず即実行するので、常に 2 タップ以内に収まる。
 */
import type { ReactNode } from 'react';
import type { ItemRow, LotRow } from '../../shared/types';
import { daysInclusive, formatYmd, today } from '../lib/date';
import { Sheet } from './Sheet';

export interface FinishLotSheetProps {
  item: ItemRow;
  lots: LotRow[];
  onClose: () => void;
  onPick: (lot: LotRow) => void;
}

export function FinishLotSheet({ item, lots, onClose, onPick }: FinishLotSheetProps): ReactNode {
  const t = today();

  return (
    <Sheet title={`${item.name} — どれを使い切った？`} onClose={onClose}>
      <ul className="space-y-2">
        {lots.map((lot, i) => (
          <li key={lot.id}>
            <button
              type="button"
              onClick={() => onPick(lot)}
              className="flex w-full items-center gap-3 rounded-2xl border border-ink-700 bg-ink-800
                px-4 py-3.5 text-left hover:bg-ink-700"
            >
              <span
                className="flex size-8 shrink-0 items-center justify-center rounded-full
                  bg-ink-700 text-xs font-bold text-zinc-300"
              >
                {i + 1}
              </span>
              <span className="min-w-0 flex-1">
                <span className="block text-sm font-semibold">{formatYmd(lot.opened_at)} 開封</span>
                <span className="block text-xs text-zinc-500">
                  {daysInclusive(lot.opened_at, t)} 日目
                  {lot.purchase_id === null && ' ・購入記録なし'}
                </span>
              </span>
              <svg viewBox="0 0 20 20" className="size-4 shrink-0 text-zinc-500" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M7 4l6 6-6 6" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
          </li>
        ))}
      </ul>
    </Sheet>
  );
}
